import { useEffect } from "react";
import { useState } from "react";
import { useGetUserQuery } from "../graphql/types";
import { GetUserQuery } from "../graphql/types";
import { fetchAuthSession } from "aws-amplify/auth";

const useGetUserFromUserIdInAuth = (): GetUserQuery["getUser"] | undefined => {
  const [cognitoSub, setCognitoSub] = useState<string | undefined>(undefined);
  useEffect(() => {
    const main = async (): Promise<void> => {
      const authSession = await fetchAuthSession();
      setCognitoSub(authSession?.tokens?.idToken?.payload?.sub);
    };
    main();
  }, []);

  const { data } = useGetUserQuery({
    variables: { userId: cognitoSub || "" },
    skip: !cognitoSub,
  });

  return data?.getUser;
};

export default useGetUserFromUserIdInAuth;
